
export default {
  auth: false,
  layout: 'login',
  head () {
    return {
      titleTemplate: this.$t('cookies_policy') + ' - %s',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('cookies')
        }
      ],
    }
  },
}
